/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export type LineCrossingTypeObject = {
  PI: 'PI';
  PO: 'PO';
  SF: 'S/F';
  SFP: 'SFP';
  NONE: 'NONE';
};

export const LineCrossingType: LineCrossingTypeObject = {
  PI: 'PI',
  PO: 'PO',
  SF: 'S/F',
  SFP: 'SFP',
  NONE: 'NONE',
};

export const lineCrossingHighlightDefault = '#FF0000';
